/*
 * @Author: 肖 学海 1379228273@qq.com
 * @Date: 2022-06-14 17:49:24
 * @LastEditors: 肖 学海 1379228273@qq.com
 * @LastEditTime: 2023-02-24 20:36:45
 * @Description: 
 */

import request from '@/utils/request'
// 获取支付详情
export function getPayInfo(params) {
    return request({
        url: '/v1/goods_order/pay_page',
        method: 'get',
        params
    })
}
// 支付
export function pay(data) {
    return request({
        url: '/v1/goods_order/pay',
        method: 'post',
        data,
        showLoading: true
    })
}
// 支付查询
export function checkGoodsOrder(params) {
    params.t = new Date().getTime()
    return request({
        url: '/v1/payment/check_goods_order',
        method: 'get',
        params,
    })
}
// 购买vip回调 修改订单状态
export function buyVipCallback(data) {
    return request({
        url: '/v1/paper_order/buyVipCallback',
        method: 'post',
        data
    })
}
export function checkip(params) {
    return request({
        url: 'v1/paper/checkIp',
        method: 'get',
        params,
    })
} 
